import {Injectable} from '@angular/core';
import { AutenticacaoStore } from './autenticacao/autenticacao-store';
import { VisualizadorService } from './visualizador/visualizador-service';
import { VisualizadorStore } from './visualizador/visualizador-store';

@Injectable()
export class Stores
{
    //Necessário injetar no construtor todas as dependências para o correto funcionamento
    constructor (
        private visualizadorStore: VisualizadorStore,
        private autenticacaoStore: AutenticacaoStore
    ) {}
}

export const STORE_PROVIDERS = [
    Stores,
    VisualizadorStore,
    VisualizadorService,
    AutenticacaoStore
];

